export default __webpack_public_path__ + "static/media/ico_car.82f96f79.svg";